import { inject, NewInstance } from 'aurelia-framework';
import { PartSizeService } from 'pages/standard-setup/part-sizes/service';
import { EventAggregator } from 'aurelia-event-aggregator';
import { DialogController } from 'aurelia-dialog';
import { ValidationRules, ValidationController, validateTrigger } from 'aurelia-validation';
import { BootstrapFormRenderer } from 'resources/validation-renderer';
import toastr from 'toastr';

@inject(DialogController, NewInstance.of(ValidationController), PartSizeService, EventAggregator)
export class PartSizeEditor {
    constructor(controller, validationController, partSizeService, ea) {
        this.controller = controller;
        this.partSizeService = partSizeService;
        this.ea = ea;
        this.partSize = {};

        this.validationController = validationController;
        this.validationController.validateTrigger = validateTrigger.manual;
        this.validationController.addRenderer(new BootstrapFormRenderer());
        this.rules = ValidationRules
            .ensure('name').required()
            .rules;
    }

    async activate(model) {
        if (model?.id != null) {
            this.partSize = await this.partSizeService.getById(model.id);
        }
    }

 

    async save() {
        if (this.isRequesting) return;
        this.isRequesting = true;
        const validationResult = await this.validationController.validate();
        if (validationResult.valid) {
            try {
                if (this.partSize.id) {
                    await this.partSizeService.update(this.partSize);
                    toastr.success('Part size was updated!');
                } else {
                    await this.partSizeService.create(this.partSize);
                    toastr.success('New part size was created!');
                }
                this.ea.publish('part-sizes:updated', this.partSize);
                this.controller.ok(this.partSize);
            } catch {
                this.isRequesting = false;
            }
        }
        this.isRequesting = false;
    }
}